import { format } from 'date-fns'

import { parseUtcDate } from '@/lib/date-utils'

/** null を空欄として扱う。0 は消さない */
export const toText = (value: string | number | boolean | null): string => {
  if (value === null) return ''
  return String(value)
}

/** 空欄は「値なし」として null に戻す。数値にならない入力は無視して null にする */
export const toNumberOrNull = (value: string): number | null => {
  const trimmed = value.trim()
  if (!trimmed) return null
  const parsed = Number(trimmed)
  if (!Number.isFinite(parsed)) return null
  return parsed
}

/** APIの naive UTC を datetime-local 入力が読める端末時刻の文字列にする */
export const toDateTimeLocal = (iso: string | null): string => {
  if (!iso) return ''
  return format(parseUtcDate(iso), "yyyy-MM-dd'T'HH:mm")
}

/** datetime-local の端末時刻をUTCのISO文字列に戻す */
export const fromDateTimeLocal = (local: string): string | null => {
  if (!local) return null
  const parsed = new Date(local)
  if (Number.isNaN(parsed.getTime())) return null
  return parsed.toISOString()
}

export const formatAmount = (amount: number | null): string => {
  if (amount === null) return '金額不明'
  return `¥${amount.toLocaleString('ja-JP')}`
}
